//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'UnLiker',
  props: ['init', 'promise', 'activate'],
  data() {
    return {
      reaction: Number(this.init) || 3,
      hoverRating: null,
      texts: {
        1: this._('Жахливо'),
        2: this._('Погано'),
        3: this._('Норм'),
        4: this._('Добре'),
        5: this._('Чудово!'),
      },
    }
  },
  computed: {
    currentRatingText() {
      return this.texts[this.hoverRating || this.reaction]
    },
    starSize() {
      return 768 > window.innerWidth ? 32 : 40
    },
  },
  watch: {
    init(val) {
      this.reaction = Number(val) || 5
    },
    reaction(val) {
      this.$emit('input', val)
    },
  },
  mounted() {
    this.$emit('input', this.reaction)
  },
  methods: {
    showCurrentRating(rating) {
      this.hoverRating = rating || null
    },
  },
}
